export default __webpack_public_path__ + "static/flaga-godlo-7606e55e08b729dfc9153d6c15109405.png";